/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Because we are committed to improving the oral healthcare knowledge of our patients, we are providing the following selection of dental videos which we hope you will find interesting and informative. We have grouped the videos into various categories to provide quick access to the topics of greatest interest to you."), "\n", React.createElement(_components.p, null, "Please contact us if you have any questions or would like to schedule an appointment."), "\n", React.createElement("iframe", {
    src: "https://www.youtube.com/embed/l3FYwtkVQ-8",
    title: "Dr. Kanuga's treatment of white spot lesions using Icon",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: true
  }), "\n", React.createElement("iframe", {
    src: "https://www.youtube.com/embed/2nyYUbsrRNo",
    title: "Local anesthetic delivery for a pediatric patient by Dr. Kanuga",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: true
  }), "\n", React.createElement("iframe", {
    src: "https://www.youtube.com/embed/22FP-tMosC4",
    title: "Pediatric Ecosite Bulk Fill Case Treatment by Dr. Kanuga",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: true
  }), "\n", React.createElement("iframe", {
    src: "https://www.youtube.com/embed/vmpN8nXrGfs",
    title: "Comprehensive Dental Treatment Under In-office General Anesthesia",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: true
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
